module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Medium.bd23b911.otf";